module.exports = __webpack_public_path__ + "img/PL00154.efc974ca.png";